import { mapBarcodeAamvaDataToAamvaString } from '../../../../backend/features/barcodesAamva/shared';
export const sampleAamvaObject = {
    ansiHeaderData: {
        badgeIssuerId: '000001',
        aamvaVersionMajor: '03',
        aamvaVersionMinor: '00',
        aamvaSubfilesCount: '01',
    },
    dajState: 'Texas',
    dakZipCode: undefined,
    dauHeight: '073 in',
    dayEyeColor: 'UNK',
    dbbDateOfBirth: '1990-01-01',
    dbcGender: '1',
    daqBadgeNumber: 'CA0013A000000000021i3v901',
    dbaExpirationDate: '2027-06-04',
    dbdIssueDate: '2025-06-04',
    dcfRevisionNumber: '001',
    dcgCountry: 'United States of America',
    dcsLastName: 'Doe',
    dctFirstAndMiddleName: 'John',
    zceAffiliation: 'Volunteer',
    zclAccessLevel: '',
    zctOccupationTitle: 'Occupation 1',
};
const { aamvaElements, ansiHeader } = mapBarcodeAamvaDataToAamvaString(sampleAamvaObject);
export const sampleAamvaStringArray = aamvaElements;
export const sampleAnsiHeader = ansiHeader;
